import type {} from "@lit/react";
import { MessageList as MessageListElement, } from "@vaadin/message-list/vaadin-message-list.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MessageListElement, };
export type MessageListEventMap = Readonly<{}>;
const events = {} as MessageListEventMap;
export type MessageListProps = WebComponentProps<MessageListElement, MessageListEventMap>;
export const MessageList = createComponent({
    elementClass: MessageListElement, events, react: React, tagName: "vaadin-message-list"
});
